import { Components } from '@mui/material';

export const MuiTableContainer: Components<any>['MuiTableContainer'] = {
  styleOverrides: {
    root: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      cursor: 'grab',
      '&:active': {
        cursor: 'grabbing !important',
      },
      '&::-webkit-scrollbar-track': {
        marginTop: '60px',
        marginBottom: '.5em',
        marginInline: '.5em',
      },
    },
  },
};
